import { TraceEventTracker } from "./TraceEventMarkerTracker";
export var getTraceTiming = function(sourceEventKey, sourceEventMarker, traceTime) {
    var currentTime = traceTime ? traceTime : performance.now();
    var sourceMarker = sourceEventMarker ? sourceEventMarker : TraceEventTracker.get().getTraceHash(sourceEventKey);
    return Math.round(currentTime - sourceMarker.sourceEventStart);
};
